import React from "react";

const HomeProductContext = React.createContext();

export default HomeProductContext;